import { render, staticRenderFns } from "./EstadoMateriales.vue?vue&type=template&id=6974daa5&scoped=true"
import script from "./EstadoMateriales.vue?vue&type=script&lang=js"
export * from "./EstadoMateriales.vue?vue&type=script&lang=js"
import style0 from "./EstadoMateriales.vue?vue&type=style&index=0&id=6974daa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6974daa5",
  null
  
)

export default component.exports